export default __webpack_public_path__ + "locales/ru/EmptyView.json?hash=04c54d0b9a71dda9327845c813eb0ed8";